// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchArticlesList_wrapper__ovmwJ"};